export default __webpack_public_path__ + "locales/hy-AM/Settings.json?hash=3a8a746d10e1fab38c58037148a8b438";